import {toPaymentInfo} from './mappers/toPaymentInfo'
import {toVerticals} from './mappers/toVerticals'
import type {FetchPaymentInfo, OrderService, OrderServiceParams, PaymentInfoModel} from './types'

export function createOrderService(params: OrderServiceParams): OrderService {
  const {dcaaRepository, draftRepository} = params
  const {fetchPaymentMethods, fetchFormOrder} = dcaaRepository

  const fetchPaymentInfo: FetchPaymentInfo = function fetchPaymentInfo(country?: string): Promise<PaymentInfoModel> {
    return fetchPaymentMethods(
      {
        should_return_only_selected: true,
        mode: 'employee',
      },
      country ? {country} : undefined,
    ).then(toPaymentInfo)
  }

  return {
    fetchPaymentInfo,
    fetchVerticals({location, country}) {
      return fetchPaymentInfo(country)
        .then(function (paymentInfo: PaymentInfoModel) {
          return fetchFormOrder(
            {
              location,
              payment_info: {
                type: paymentInfo.type,
                method_id: paymentInfo.methodId,
                kind: paymentInfo.kind,
              },
            },
            country ? {country} : undefined,
          )
        })
        .then(toVerticals)
    },
    fetchCreateClaim() {
      throw new Error('Function "fetchCreateClaim" not implemented.')
    },
    // [черновик] начало
    fetchPersistDraftSync(draft) {
      draftRepository.fetchPersistDraftSync(draft)
    },
    fetchRestoreDraftSync() {
      return draftRepository.fetchRestoreDraftSync()
    },
    fetchClearDraftSync() {
      draftRepository.fetchClearDraftSync()
    },
    // [черновик] конец
  }
}
